import { VehicleDefinitionResource, VehicleRegistrationResource, VehicleMileageLogResource } from '../../classes/Api/Vehicle';
import Moment from 'moment';
import { mapState } from 'vuex'

export let VehicleIdentityHelpers = {
    data() {
        return {
            lookupCompleted: false,
            isPartialResponse: false,
        }
    },
    computed: {
        ...mapState({ 
            identity: state => state.identity.current,
        }),
    },
    methods: {
        // Handle the response from the VehicleLookup component, we need to 
        // either find the vehicle or create it.
        findOrCreateVehicle(identity, params = {}) {

            return (new Promise((resolve, reject) => {
                // Try finding the vehicle.
                VehicleDefinitionResource.find(identity.vin.toUpperCase(), params)

                    // Resolve the promise if we find it.
                    .then((response) => {
                        resolve([identity, response.data]);
                    }, 

                    // Try creating it if it was not found or handle other errors.
                    (error) => {
                        if (404 === error.response.status) {
                            this.createVehicleFromIdentity(identity, params).then(resolve, reject)
                        } else {
                            handleApiError(error, reject)
                        }
                    });
            }));
        },
        createVehicleFromIdentity(identity, params = {}) {
            return new Promise((resolve, reject) => {
                let model = {
                    "vin": identity.vin,
                    "engine_number": identity.engine_number,
                    "manufacturer_id": identity.manufacturer.id,
                    "model_id": identity.model.id,
                    "derivative": identity.derivative,
                    "body_type": identity.body_type,
                    "fuel_type": identity.fuel_type,
                    "emission_class": identity.emission_class,
                    "transmission_type": identity.transmission_type,
                    "engine_size": identity.engine_size,
                    "co2": identity.co2,
                    "colour": identity.colour,
                    "number_of_doors": identity.number_of_doors,
                    "number_of_seats": identity.number_of_seats,
                    "registration_date": Moment(identity.registration_date).format('YYYY-MM-DD HH:mm:ss'),
                    "year_of_manufacture": identity.year_of_manufacture,
                    "plate": identity.plate,
                    "is_imported": identity.is_imported,
                    "specification_id": identity.specification_id,
                    "specification_driver": identity.specification_driver,
                    "vehicle_type": identity.vehicle_type,
                    "owners": identity.owners,
                    "has_temporary_vin": identity.has_temporary_vin,
                    "is_new_or_unregistered": identity.is_new_or_unregistered,
                    "bedroom_layout": identity.bedroom_layout,
                    "end_layout": identity.end_layout,
                    "berths": identity.berths,
                    "bedrooms": identity.bedrooms
                };

                VehicleDefinitionResource.store(model, params)
                    .then((response) => {
                        this.addVehicleRegistrations(response.data, identity, (registration) => {
                            response.data.registration = registration;

                            (new Promise((resolve, reject) => {
                                // If the mileage is empty try getting an estimate.
                                if (_.isEmpty(identity.mileage) && !identity.is_new_or_unregistered) {
                                    VehicleMileageLogResource.forVehicle(response.data.id).estimate().then(response => {
                                        resolve({ mileage: response.data.mileage, type: 'estimated' })
                                    }, e => { handleApiError(e); reject() })
                                } 
                                // Otherwise, just return the mileage.
                                else {
                                    resolve({ mileage: identity.mileage, type: 'input'})
                                }
                            })).then(({ mileage, type }) => {
                                let message = 'Initial mileage entered';

                                if ('estimated' === type) {
                                    message = 'Estimated mileage'
                                }

                                // Add the vehicle mileage.   
                                this.addVehicleMileage(response.data, mileage, message).then((mileage) => {
                                    response.data.mileage = mileage;

                                    resolve([identity, response.data]);
                                }, error => { handleApiError(error, reject) });
                            });
                        });
                    }, (error) => {
                        handleApiError(error, reject)
                    });  
            })
        },
        addVehicleRegistrations(vehicle, identity, callback) {
            const addVrm = (vrm, id) => {
                vrm = vrm.replace(' ', '');
                return VehicleRegistrationResource.forVehicle(id)
                    .store({vrm}).catch(handleApiError)
            }

            addVrm(identity.registration, vehicle.id).then(response => {
                let promises = []

                identity.other_registrations.forEach((vrm) => {
                    promises.push(addVrm(vrm, vehicle.id))
                })

                if (promises.length > 0) {
                    Promise.all(promises).then((responses) => {
                        callback(response.data);
                    })
                } else {
                    callback(response.data);
                }
            })
        },
        addVehicleMileage(vehicle, miles, notes) {
            return new Promise((resolve, reject) => {
                VehicleMileageLogResource.forVehicle(vehicle.id)
                    .store({miles, notes, date: new Date()}).then((response) => {
                        resolve(response.data);
                    }, (error) => {
                        handleApiError(error, reject)
                    });
            })
        },
        handleVehicleDefinition(data) {
            this.handleLookupSuccess(data);
        },
        handleLookupSuccess(data) {
            let shouldShowDefinition = (
                data.response_type.indexOf('Partial') > -1 || 
                this.identity.colour.trim().length === 0 ||
                (!this.identity.is_new_or_unregistered && !this.identity.owners ||
                !this.identity.is_new_or_unregistered && this.identity.owners.length === 0) ||
                this.identity.transmission_type.length === 0 ||
                this.identity.body_type.length === 0
            );

            console.log('Show Definition?', shouldShowDefinition)

            if (shouldShowDefinition) {

                // Partial responses have a response type, requests from manual lookups do not.
                if (data.response_type) {
                    this.isPartialResponse = true;
                }
                
                // If we don't have enough details to create a vehicle 
                // definition we launch a modal to collect the rest 
                // of the details.
                this.$emit('show-definition-modal')
            } else {
                this.lookupCompleted = true;
                console.log('Creating vehicle...', this.identity)

                // Assign a temporary VIN if needed.
                if (this.identity.has_temporary_vin) {
                    this.identity.vin = 'DKV' + (
                        Math.random().toString(36).substring(2, 9) +
                        Math.random().toString(36).substring(2, 9)
                    ).toUpperCase()
                }

                // Assign a registration if not registered.
                if (this.identity.is_new_or_unregistered) {
                    this.identity.registration = 'NO REG'
                    this.identity.owners = 0
                }

                // Otherwise we can try to find or create the vehicle and show 
                // the pricing & delivery info modal.
                this.findOrCreateVehicle(this.identity, { with: ['currentInstance'] }).then(data => {

                    // Update the vehicle mileage if needed.
                    if (data[0].mileage && parseInt(data[0].mileage) !== parseInt(data[1].mileage)) {
                        this.addVehicleMileage(data[1], data[0].mileage, 'Added to stock').then((mileage) => {
                            this.$emit('vehicle-created', data);
                        }, error => {
                            handleApiError(error, reject)
                        });
                    } else {
                        this.$emit('vehicle-created', data);
                    }

                }, e => { this.$emit('vehicle-creation-failed', e) });
            }
        }
    }
}